import AdxButton from 'components/custom/AdxButton'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import React, { useState } from 'react'

const WithdrawRequestWarning = ({ handleWithdraw }) => {
  const { fx, ...rest } = handleWithdraw
  const [isModalOpen, setModalOpen] = useState(false)
  const handleOpen = () => {
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
  }
  return (
    <>
      <AdxButton variant={'outlined'} onClick={handleOpen} sx={{ width: '100%' }}>
        Withdraw
      </AdxButton>
      <AdxInfoModal
        open={isModalOpen}
        onClose={handleClose}
        muiIcon="warning"
        iconColor="warning.main"
        title="Are you sure you want to withdraw your leave request?"
        subtitle=""
        footerButtons
        firstBtnLabel={'Confirm'}
        firstBtnHandle={fx}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={handleClose}
      />
    </>
  )
}

export default WithdrawRequestWarning
